import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MenuBurgerSize } from '@shared/components/menu-burger/enum';
import { Color } from '@shared/enums';
import { ColorPipe } from '@shared/pipes';

@Component({
  selector: 'app-menu-burger',
  templateUrl: './menu-burger.component.html',
  styleUrl: './menu-burger.component.scss',
  imports: [ColorPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuBurgerComponent {
  readonly color = input.required<keyof typeof Color>();
  readonly size = input.required<keyof typeof MenuBurgerSize>();
  readonly centered = input.required<boolean>();
  readonly withText = input.required<boolean>();
  readonly isOpen = input(false);

  readonly isOpenChange = output<boolean>();
}
